import { Record } from 'immutable';

export default class PhotoRecord extends Record({
  id: undefined,
  mlnum: null,
  url: '',
  photoFilename: '',
  photoDescription: '',
  photoOrder: null,
  photoTimestamp: '',
  lookupUID: null
}) {}



// WEBPACK FOOTER //
// ./src/records/Photo.js